/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, RoutePath } from "../../../utility/Constant";

const JobsUniquePage = () => {
  const { jobsApi } = apiPath;
  const [uniqueData, uniqueLoading] = useFetch(jobsApi);
  const [filteredData, setFilteredData] = useState();
  let { id } = useParams();

  useEffect(() => {
    setFilteredData(uniqueData?.filter((item) => item._id === id)[0]);
  }, [uniqueData, id]);

  if (uniqueLoading || !filteredData?._id) {
    return <Loading />;
  }

  const { title, subtitle, description, date, job_no, country_name, _id, status } =
    filteredData ?? {};

  // console.log(filteredData);

  const data = [
    {
      elementType: "input",
      label: "title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "input",
      label: "subtitle",
      type: "Text",
      name: "subtitle",
      defaultValue: subtitle,
      required: false,
    },
    {
      elementType: "input",
      label: "date",
      type: "date",
      name: "date",
      defaultValue: date,
      required: false,
    },
    {
      elementType: "input",
      label: "country name",
      type: "Text",
      name: "country_name",
      defaultValue: country_name,
      required: false,
    },
    {
      elementType: "richTextEditor",
      label: "description",
      type: "richTextEditor",
      name: "description",
      defaultValue: description,
      required: false,
    },
    {
      elementType: "select",
      label: "Job Status",
      type: "select",
      name: "status",
      options: ["active", "hired", "hidden"],
      defaultValue: status,
      required: false,
    },
  ];

  const update = (data) => {
    data.slug = "content";
    updateData(jobsApi, data, _id);
    setTimeout(() => {
      window.location.href = "/" + RoutePath.jobsContent;
    }, 800);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default JobsUniquePage;
